export default "__VITE_ASSET__5d05bcd6__"